<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="row mt-5">
          <div class="form-group">
            <div class="form-label-group ml-4">
              <input
                type="text"
                id="inputSearch"
                class="form-control"
                placeholder="ძებნა"
              />
              <label for="inputSearch">ძებნა</label>
            </div>
          </div>
          <i class="fa fa-search searchBtn ml-3 mt-1" title="ძებნა"></i>
          <i
            class="fa fa-plus-circle addNewBtn mt-1 ml-4"
            title="ლატარიის წევრების დამატება"
            data-toggle="modal"
            data-target="#exampleModalLong"
            @click="clearData(), modalPrepare()"
          ></i>
        </div>
      </div>
    </div>
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLong"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              ლატარიის წევრების დამატება
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <label for="lotteryAdd">ლატარია</label>
                <autocomplete
                  id="lotteryAdd"
                  :list="lotteryArray"
                  optionField="nameGe"
                  @input="onAutocompleteInputLottery"
                >
                  <div slot="list-item" slot-scope="{ item }">
                    {{ item.nameGe }}
                    <br />
                    {{ item.descriptionGe }}
                  </div>
                </autocomplete>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="memberTypeAdd"
                      class="form-control margin-top-6"
                      placeholder="წევრის ტიპი"
                      autofocus="autofocus"
                      v-model="lotteryMember.memberType"
                      v-on:input="$v.lotteryMember.$touch"
                      v-bind:class="{
                        'error-border': $v.lotteryMember.memberType.$error,
                        valid:
                          $v.lotteryMember.memberType.$dirty &&
                          !$v.lotteryMember.memberType.$invalid,
                      }"
                    />
                    <label for="memberTypeAdd">წევრის ტიპი</label>
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <label for="lotteryAdd">ბრენდი</label>
                <autocomplete
                  :list="legalBrandsArray"
                  optionField="nameGe"
                  @input="onAutocompleteInputBrand"
                >
                  <div slot="list-item" slot-scope="{ item }">
                    {{ item.nameGe }}
                    <br />
                    {{ item.descGe }}
                  </div>
                </autocomplete>
              </form>
            </div>
          </div>
          <div class="modal-footer mt-5">
            <button
              type="button"
              class="btn btn-danger mt-5"
              data-dismiss="modal"
            >
              დახურვა
            </button>
            <button
              v-if="!isActive"
              type="button"
              class="btn btn-success mt-5"
              :disabled="!$v.lotteryMember.$dirty || $v.lotteryMember.$error"
              @click="$v.lotteryMember.$touch(), addLotteryMember()"
              data-dismiss="modal"
            >
              დამახსოვრება
            </button>
            <button
              v-if="isActive"
              type="button"
              class="btn btn-success mt-5"
              :disabled="!$v.lotteryMember.$dirty || $v.lotteryMember.$error"
              @click="$v.lotteryMember.$touch(), editLotteryMember()"
              data-dismiss="modal"
            >
              რედაქტირება
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="no-more-tables">
      <table
        class="col-md-12 table-bordered table-striped table-condensed cf mt-5"
      >
        <thead class="cf" style="border-style: none">
          <tr>
            <th class="numeric">წევრის სახელი</th>
            <th class="numeric">წევრის ტიპი</th>
            <!-- <th class="numeric">ltLotteryMembers</th> -->
          </tr>
        </thead>
        <tbody>
          <tr
            class="heading"
            v-for="valueLotteryMember in lotteryMembersArray"
            :key="valueLotteryMember.id"
          >
            <td data-title="სახელი ქართულად" class="numeric">
              {{ valueLotteryMember.memberName }}
            </td>
            <td data-title="English Name" class="numeric">
              {{ valueLotteryMember.memberType }}
            </td>
            <!-- <td data-title="имя на русском" class="numeric">{{ valueLotteryMember.ltLotteryMembers }}</td> -->
            <td data-title="რედაქტირება" class="numeric">
              <div>
                <i
                  class="fa fa-pencil-alt fa-fw editBtn"
                  title="რედაქტირება"
                  data-toggle="modal"
                  data-target="#exampleModalLong"
                  @click="
                    editFillInputs(valueLotteryMember), modalPrepareEdit()
                  "
                ></i>
                <i
                  class="fas fa-trash fa-fw deleteBtn"
                  title="წაშლა"
                  data-toggle="modal"
                  data-target="#exampleModalLongDelete"
                  @click="getDeleteId(valueLotteryMember.id)"
                ></i>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongEdit"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5
              class="modal-title text-white"
              id="exampleModalLongTitle"
            >ლატარიის წევრების რედაქტირება</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <form class="col-12 col-md-6">
                <label for="lotteryEdit">ლატარია</label>
                <autocomplete
                  id="lotteryEdit"
                  :list="lotteryArray"
                  optionField="nameGe"
                  @input="onAutocompleteInputLottery"
                >
                  <div slot="list-item" slot-scope="{item}">
                    {{item.nameGe}}
                    <br>
                    {{item.descriptionGe}}
                  </div>
                </autocomplete>
                <div class="form-group">
                  <div class="form-label-group">
                    <input
                      type="text"
                      id="memberTypeEdit"
                      class="form-control margin-top-6"
                      placeholder="წევრის ტიპი"
                      autofocus="autofocus"
                      v-model="lotteryMember.memberType"
                      v-on:input="$v.lotteryMember.$touch"
                      v-bind:class="{'error-border': $v.lotteryMember.memberType.$error, valid: $v.lotteryMember.memberType.$dirty && !$v.lotteryMember.memberType.$invalid}"
                    >
                    <label for="memberTypeEdit">წევრის ტიპი</label>
                  </div>
                </div>
              </form>
              <form class="col-12 col-md-6">
                <label for="lotteryEdit">ბრენდი</label>
                <autocomplete
                  :list="legalBrandsArray"
                  optionField="nameGe"
                  @input="onAutocompleteInputBrand"
                >
                  <div slot="list-item" slot-scope="{item}">
                    {{item.nameGe}}
                    <br>
                    {{item.descGe}}
                  </div>
                </autocomplete>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">დახურვა</button>
            <button
              type="button"
              class="btn btn-success"
              :disabled="!$v.lotteryMember.$dirty || $v.lotteryMember.$error"
              @click="$v.lotteryMember.$touch(), editLotteryMember()"
              data-dismiss="modal"
            >რედაქტირება</button>
          </div>
        </div>
      </div>
    </div> -->
    <div
      class="modal fade bd-example-modal-lg"
      id="exampleModalLongDelete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header green-color">
            <h5 class="modal-title text-white" id="exampleModalLongTitle">
              ლატარიის წევრების წაშლა
            </h5>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">გსურთ წაშლა?</div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-dismiss="modal">
              დახურვა
            </button>
            <button
              type="button"
              class="btn btn-success"
              @click="deleteLotteryMember()"
              data-dismiss="modal"
            >
              წაშლა
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../../assets/js/sb-admin.min.js";
import "../../assets/vendor/datatables/jquery.dataTables.js";
import "../../assets/vendor/datatables/dataTables.bootstrap4.js";
import "../../assets/js/demo/datatables-demo.js";
import { bus } from "../common/bus";
import ProductMenuGroupTemplate from "../common/ProductMenuGroupTemplate.vue";
import { required } from "vuelidate/lib/validators";

export default {
  name: "lotteryMember",
  components: { autocomplete: ProductMenuGroupTemplate },
  data() {
    return {
      showModal: false,
      lotteryMember: {
        id: "",
        lotteryId: null,
        memberName: "",
        memberType: "",
        memberId: null,
      },
      legalBrand: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descGe: "",
        descEn: "",
        descRu: "",
        logoSrc: null,
        lBCategoryId: null,
      },
      lottery: {
        id: null,
        nameGe: "",
        nameEn: "",
        nameRu: "",
        descriptionGe: "",
        descriptionEn: "",
        descriptionRu: "",
        startDate: null,
        endDate: null,
        status: false,
        raffleDateAndTime: null,
        image: "",
      },
      isActive: false,
      lotteryMembersArray: [],
      specialItemsAutocompleteArray: [],
      legalBrandsArray: [],
      lotteryArray: [],
    };
  },
  validations: {
    lotteryMember: {
      lotteryId: {
        required,
      },
      memberName: {
        required,
      },
      memberType: {
        required,
      },
      memberId: {
        required,
      },
    },
  },
  async created() {
    let lotteryMemberResult = await this.$http.getLotteryMember();
    this.lotteryMembersArray = lotteryMemberResult.data.res;

    let lotteryResult = await this.$http.getLottery();
    this.lotteryArray = lotteryResult.data.res;

    let legalBrandResult = await this.$http.getLegalBrand();
    this.legalBrandsArray = legalBrandResult.data.res;
  },
  methods: {
    async addLotteryMember() {
      let lotteryMemberAddObject = {
        lotteryId: this.lotteryMember.lotteryId,
        memberName: this.lotteryMember.memberName,
        memberType: this.lotteryMember.memberType,
        memberId: this.lotteryMember.memberId,
      };
      try {
        let lotteryMemberAddResult = await this.$http.postLotteryMember(
          lotteryMemberAddObject
        );

        if (lotteryMemberAddResult.data.resultCode === "200") {
          bus.$emit("success", "სპეციალური ჯგუფი წარმატებით დაემატა");
          let lotteryMemberResult = await this.$http.getLotteryMember();
          this.lotteryMembersArray = lotteryMemberResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "ლატარიის წევრების დამატების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editLotteryMember() {
      try {
        let lotteryMemberEditResult = await this.$http.putLotteryMember(
          this.lotteryMember
        );

        if (lotteryMemberEditResult.data.resultCode === "200") {
          bus.$emit("success", "ლატარიის წევრი წარმატებით დარედაქტირდა");
          let lotteryMemberResult = await this.$http.getLotteryMember();
          this.lotteryMembersArray = lotteryMemberResult.data.res;
        } else {
          bus.$emit(
            "warning",
            "ლატარიის წევრის რედაქტირების დროს მოხდა შეცდომა"
          );
        }
      } catch (error) {
        bus.$emit("error", error);
      }
      this.autocomplete = !this.autocomplete;
    },
    async deleteLotteryMember() {
      try {
        let lotteryMemberDeleteResult = await this.$http.deleteLotteryMember(
          this.lotteryMember.id
        );

        if (lotteryMemberDeleteResult.data.resultCode === "200") {
          bus.$emit("success", "ლატარიის წევრი წარმატებით წაიშალა");
          let lotteryMemberResult = await this.$http.getLotteryMember();
          this.lotteryMembersArray = lotteryMemberResult.data.res;
        } else {
          bus.$emit("warning", "ლატარიის წევრის წაშლის დროს მოხდა შეცდომა");
        }
      } catch (error) {
        bus.$emit("error", error);
      }
    },
    async editFillInputs(row) {
      console.log(row);
      let lotteryMemberResult = await this.$http.getByIDLotteryMember(row.id);
      this.lotteryMember = lotteryMemberResult.data.res;
      console.log(this.lotteryMember);
    },
    getDeleteId(id) {
      this.lotteryMember.id = id;
    },
    onAutocompleteInputLottery(object) {
      this.lotteryMember.lotteryId = object.id;
    },
    onAutocompleteInputBrand(object) {
      this.lotteryMember.memberName = object.nameGe;
      this.lotteryMember.memberId = object.id;
    },
    modalPrepareEdit() {
      this.isActive = true;
    },
    modalPrepare() {
      this.isActive = false;
    },
    clearData() {
      this.lotteryMember.id = null;
      this.lotteryMember.lotteryId = null;
      this.lotteryMember.memberName = "";
      this.lotteryMember.memberType = "";
      this.lotteryMember.memberId = null;
      this.legalBrand.id = null;
      this.legalBrand.nameGe = "";
      this.legalBrand.nameEn = "";
      this.legalBrand.nameRu = "";
      this.legalBrand.descGe = "";
      this.legalBrand.descEn = "";
      this.legalBrand.descRu = "";
      this.legalBrand.logoSrc = null;
      this.legalBrand.lBCategoryId = null;
      this.lottery.id = null;
      this.lottery.nameGe = "";
      this.lottery.nameEn = "";
      this.lottery.nameRu = "";
      this.lottery.descriptionGe = "";
      this.lottery.descriptionEn = "";
      this.lottery.descriptionRu = "";
      this.lottery.startDate = null;
      this.lottery.endDate = null;
      this.lottery.status = false;
      this.lottery.raffleDateAndTime = null;
      this.lottery.image = "";
      this.resetAutocomplete = !this.resetAutocomplete;
      this.selectedspecialItemsArray = [];
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
@import "../../assets/scss/_mixins.scss";
@import "../../assets/scss/_navbar.scss";
@import "../../assets/scss/sb-admin.scss";
@import "../../assets/css/sb-admin.css";
@import "../../assets/vendor/datatables/dataTables.bootstrap4.css";
@import "../../assets/scss/_login.scss";
@import "../../assets/scss/_global.scss";

// .margin-top-6 {
//   margin-top: 100px;
// }

// .error-border {
//   border-color: #ffb3b3;
//   box-shadow: none;
// }

// .modal-nav-button {
//   margin-left: 15px;
// }

// .modal-nav {
//   color: #52af8e;
// }

// .editBtn {
//   margin-left: 10px;
//   font-size: 30px;
//   cursor: pointer;
//   color: #52af8e;
// }
// .deleteBtn {
//   font-size: 30px;
//   cursor: pointer;
//   color: #d43f3a;
//   margin-left: 10px;
// }

// .searchBtn {
//   font-size: 40px;
//   margin-top: -5px;
//   cursor: pointer;
//   color: #489d7f;
// }

// .addNewBtn {
//   font-size: 44px;
//   margin-left: 15px;
//   cursor: pointer;
//   color: #52af8e;
//   margin-top: -5px;
// }

// .pointer {
//   cursor: pointer;
// }

// .modal-card {
//   background-color: #eef7f4;
// }

// @media only screen and (min-width: 1450px) {
//   #no-more-tables table {
//     border-style: none;
//   }
//   #no-more-tables th {
//     padding: 12px;
//     font-weight: bold;
//     border-style: none;
//     border-bottom: solid #212529 4px;
//   }
//   #no-more-tables td {
//     padding: 10px;
//     font-family: "BPGNinoMtavruli";
//     border-style: none;
//     border-bottom: solid #212529 2px;
//   }
// }

// @media only screen and (max-width: 1450px) {
//   .deleteBtn {
//     margin-left: 5px;
//   }
//   #no-more-tables table,
//   #no-more-tables thead,
//   #no-more-tables tbody,
//   #no-more-tables th,
//   #no-more-tables td,
//   #no-more-tables tr {
//     display: block;
//     border-style: none;
//   }
//   #no-more-tables thead tr {
//     position: absolute;
//     top: -9999px;
//     left: -9999px;
//   }
//   #no-more-tables tr {
//     border-bottom: 4px solid #212529;
//   }
//   #no-more-tables td {
//     border-bottom: 1px solid #eee;
//     position: relative;
//     padding-left: 50%;
//     white-space: normal;
//     text-align: left;
//   }
//   #no-more-tables td:before {
//     position: absolute;
//     top: 6px;
//     left: 6px;
//     width: 45%;
//     padding-right: 10px;
//     white-space: nowrap;
//     text-align: left;
//     font-weight: bold;
//   }
//   #no-more-tables td:before {
//     content: attr(data-title);
//   }
// }
// @media only screen and (max-width: 600px) {
//   .container {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
//   #no-more-tables table {
//     padding-left: 0px;
//     padding-right: 0px;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/view/LotteryMember.vue